import styled, { css } from 'styled-components'

import { colors } from '@/styles'

import { FaqAnswer, FaqLink, FaqStep } from './types'

interface FAQContentProps {
  content: { answers?: FaqAnswer[] }
}

const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ItemContainer = styled.div`
  display: inline-block;
  padding-bottom: 20px;
`

const textStyle = css`
  font-family: Inter, sans-serif;
  font-size: 16px;
  color: ${colors.grey56};
  line-height: 24px;
  display: inline;
`

export const AnswerHeading = styled.p`
  ${textStyle}
  padding-bottom: 12px;
  font-weight: 700;
`

export const ItemLink = styled.a`
  ${textStyle}
  word-wrap: break-word;
  color: ${colors.link};
  padding: 0;
  background: none;
  text-decoration: underline;
`

const ItemText = styled.p`
  ${textStyle}
`

const renderSteps = (step: FaqStep, index: number) => {
  const stepObject = step as FaqLink
  if (stepObject?.href) {
    return (
      <ItemLink key={`${step}-${index}`} href={stepObject.href}>
        {stepObject.text}
      </ItemLink>
    )
  } else if (stepObject?.onClick) {
    return (
      <ItemLink
        key={`${stepObject?.text}-${index}`}
        onClick={stepObject.onClick}
        as="button"
        type="button"
      >
        {stepObject.text}
      </ItemLink>
    )
  } else {
    return (
      <ItemText key={`${step}-${index}`}>{step as React.ReactNode}</ItemText>
    )
  }
}

const FAQContent: React.FC<FAQContentProps> = props => {
  const { content = {} } = props
  const { answers = [] } = content

  return (
    <>
      {answers &&
        answers.map((answer, answerIndex) => {
          const { steps } = answer

          return (
            <AccordionContent key={`faq-accordion-${answerIndex}`}>
              {answer.heading && (
                <AnswerHeading>{answer.heading}</AnswerHeading>
              )}
              {steps && (
                <ItemContainer>
                  {steps.map((step, stepIndex) => {
                    return renderSteps(step, stepIndex)
                  })}
                </ItemContainer>
              )}
            </AccordionContent>
          )
        })}
    </>
  )
}

export default FAQContent
